import { WritingSystemDirection } from '@bg-shared/enums/WritingSystemDirection';

export const getDirection = (isRtl: boolean): WritingSystemDirection =>
    isRtl ? WritingSystemDirection.RTL : WritingSystemDirection.LTR;
